export function localeUses24HourTime (langCode?: string) {
  return new Intl.DateTimeFormat(langCode, {
    hour: 'numeric'
  })?.formatToParts(new Date(2020, 0, 1, 13)).find(part => part.type === 'hour')?.value.length === 2
}
